import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { KineticLines } from "../components/KineticLines";
import { Reveal } from "../components/Reveal";
import { WhatsAppCTA } from "../components/WhatsAppCTA";
import { CONTACTS, SOCIALS } from "../data/content";

export default function Contatti() {
  return (
    <section data-testid="contatti-page" className="mx-auto max-w-[1400px] px-5 pb-24 pt-28 md:px-10 md:pt-40 md:pb-32">
      <Reveal y={12}>
        <div className="mb-8 flex items-center gap-3">
          <span className="h-2.5 w-2.5 bg-orange" aria-hidden="true" />
          <span className="font-oswald text-xs uppercase tracking-[0.3em] text-navy md:text-sm">Contatti</span>
        </div>
      </Reveal>
      <KineticLines
        lines={["Parliamone", <span key="p" className="text-orange">di persona.</span>]}
        className="font-oswald text-[clamp(2.8rem,8vw,7rem)] font-semibold uppercase leading-[0.95] tracking-tight"
      />

      <div className="mt-16 grid gap-12 lg:grid-cols-12">
        <div className="space-y-0 lg:col-span-7">
          <Reveal>
            <a
              href={`mailto:${CONTACTS.email}`}
              data-testid="contact-email-link"
              className="group flex items-start gap-5 border-t border-ink py-8 transition-colors duration-300 hover:bg-navy/5 md:py-10"
            >
              <Mail className="mt-2 h-6 w-6 shrink-0 text-orange" aria-hidden="true" />
              <div>
                <p className="font-oswald text-xs uppercase tracking-[0.25em] opacity-60">Scrivici una mail</p>
                <p className="mt-2 break-all font-oswald text-2xl font-semibold tracking-tight transition-colors duration-300 group-hover:text-orange md:text-4xl">
                  {CONTACTS.email}
                </p>
              </div>
            </a>
          </Reveal>
          <Reveal delay={0.1}>
            <div data-testid="contact-phone-row" className="flex items-start gap-5 border-t border-ink py-8 md:py-10">
              <Phone className="mt-2 h-6 w-6 shrink-0 text-orange" aria-hidden="true" />
              <div>
                <p className="font-oswald text-xs uppercase tracking-[0.25em] opacity-60">Chiamaci</p>
                <p className="mt-2 font-oswald text-2xl font-semibold tracking-tight md:text-4xl">{CONTACTS.phoneDisplay}</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div data-testid="contact-address-row" className="flex items-start gap-5 border-y border-ink py-8 md:py-10">
              <MapPin className="mt-2 h-6 w-6 shrink-0 text-orange" aria-hidden="true" />
              <div>
                <p className="font-oswald text-xs uppercase tracking-[0.25em] opacity-60">Dove ci trovi</p>
                <p className="mt-2 font-oswald text-2xl font-semibold tracking-tight md:text-4xl">{CONTACTS.address}</p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="lg:col-span-5">
          <div data-testid="contact-whatsapp-card" className="flex h-full flex-col justify-between border border-ink bg-navy p-8 text-bone md:p-12">
            <div>
              <span className="block h-2.5 w-2.5 bg-orange" aria-hidden="true" />
              <h2 className="mt-6 font-oswald text-3xl font-semibold uppercase leading-tight tracking-tight md:text-4xl">
                Il modo più <span className="text-orange">veloce:</span> WhatsApp
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-bone/75">
                Domande, idee o segnalazioni dal tuo quartiere: mandaci un messaggio e ti risponderemo al più presto.
              </p>
              <p className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-bone/50">
                <Clock className="h-4 w-4" aria-hidden="true" /> Rispondiamo entro 48 ore
              </p>
            </div>
            <div className="mt-10">
              <WhatsAppCTA big testId="contact-whatsapp-button" label="Apri WhatsApp" />
              <a
                href={SOCIALS.whatsappChannel}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-channel-link"
                className="mt-4 block text-center text-sm text-bone/70 underline underline-offset-4 transition-colors duration-300 hover:text-orange"
              >
                Oppure entra nel nostro canale WhatsApp
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
